import styled from "styled-components"


const CurrencyLogo = styled.img`
    pointer-events: auto;
    src: $(props => props.src);
    width: 30px;
    height: 30px;
    margin: 0, auto;
    align-self: top;
    margin-right: 0.3em;
    align-self: center;
    justify-content: center;
    text-align: center;

	/* Tablets */
	@media (max-width: 1400px) {
    	margin-right: 0.3em;
		width: 20px;
		height: 20px;
	}

	/* Mobiles */
	@media (max-width: 640px) {
    	margin-right: 0.2em;
		width: 15px;
		height: 15px;
	}
`;

export default CurrencyLogo;

